import { useTheme } from "@mui/material";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const Publishers: React.FC<SvgIconProps> = (props) => {
  const theme = useTheme();

  return (
    <SvgIcon {...props} viewBox="0 0 18 18" fill="none">
      <svg
        width="18"
        height="19"
        viewBox="0 0 18 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.8 18.0702V15.2643C1.305 15.2643 0.8814 15.0779 0.5292 14.705C0.177 14.332 0.0006 13.8832 0 13.3585V2.8761C0 2.35198 0.1764 1.90346 0.5292 1.53054C0.882 1.15763 1.3056 0.97085 1.8 0.970215H16.2C16.695 0.970215 17.1189 1.15699 17.4717 1.53054C17.8245 1.9041 18.0006 2.35261 18 2.8761V13.3585C18 13.8826 17.8239 14.3314 17.4717 14.705C17.1195 15.0785 16.6956 15.265 16.2 15.2643V18.0702H15.3L14.715 15.2643H3.3075L2.7 18.0702H1.8ZM1.8 13.3585H16.2V2.8761H1.8V13.3585Z"
          fill={theme.palette.brandedTypography.textColor}
        />
      </svg>
      ;
    </SvgIcon>
  );
};

export default Publishers;
